import { Link } from "react-router-dom";
import { imgUrl } from "../lib/api";

const ABOUT_IMG = imgUrl("/api/static/site/about_maker.webp");

export default function About() {
  return (
    <div data-testid="about-page" className="bg-stone-950 text-stone-50 pt-14 pb-24">
      <div className="max-w-[1400px] mx-auto px-6 sm:px-12 lg:px-16">
        <p className="text-overline text-amber-600 mb-4">About</p>
        <h1 className="font-display text-5xl sm:text-7xl font-black tracking-tighter uppercase leading-[0.95] max-w-3xl">
          One bench.
          <br />
          One pair of hands.
        </h1>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 mt-20 items-start">
          <div className="lg:col-span-7 order-2 lg:order-1">
            <div className="space-y-6 text-stone-300 leading-relaxed text-lg">
              <p>
                Wood by ZQ started in a garage and stayed that way. Every
                board, box and bowl that leaves here was selected, milled,
                glued, sanded and finished by the same set of hands.
              </p>
              <p>
                I work mostly in domestic hardwoods — black walnut, hard maple,
                cherry, white oak — because they hold up, age beautifully, and
                each tree has its own grain story. Live edge gets kept where
                it earns its place. Resin inlays go in only when the wood asks
                for it.
              </p>
              <p>
                Custom builds are where it gets interesting. If you've got a
                shape or a use-case in mind, send a message. The hardest part
                of a commission is usually figuring out what you actually want
                — that's the part I like.
              </p>
            </div>

            <Link
              to="/custom"
              data-testid="about-cta"
              className="inline-block mt-12 bg-amber-700 hover:bg-amber-600 text-stone-50 px-8 py-4 text-overline transition-colors"
            >
              Start a project →
            </Link>
          </div>

          <div className="lg:col-span-5 order-1 lg:order-2">
            <div className="aspect-[4/3] lg:aspect-[4/5] overflow-hidden border border-stone-800 bg-stone-900">
              <img
                src={ABOUT_IMG}
                alt="ZQ checking a board in the workshop"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
